<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!-- 점검 정보 -->
    <div class="mt-5 mb-6">
      <p class="title my-4"><i class="dot"></i>점검정보</p>
      <div class="grid xl:grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">담당부서</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_1 }} </span>
          <company-selector
            v-else
            v-model="form.inputB_0"
            :companyName="form.inputB_1"
            @select="targetCompany"
            :readonly="board.readonly"
            class="w-full flex-1"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">점검 및 평가자</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_2 }} </span>
          <ml-input
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder=""
            v-model="form.inputB_2"
          />
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">평가일자</div>
          <span v-if="isPrint" class="print-input"> {{ form.inputB_3 }} </span>
          <DateSelector
            v-else
            :readonly="board.readonly"
            class="w-full flex-1"
            placeholder="날짜선택"
            v-model="form.inputB_3"
          />
        </div>
      </div>
    </div>

    <!--    점검항목-->
    <table-inspect-merge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      title="안전보건 체크리스트"
      :numbering="true"
      :table-header-title="[
        {'text': '의무사항', style:'', colspan: 1},
        {'text': '관계법령', style:'', colspan: 1},
        {'text': '세부내용', style:'', colspan: 1},
        {'text': '점검 항목', style:'', colspan: 1}]"
      table-header-yes="양호"
      table-header-no="미흡"
      table-header-na="해당없음"
      :table-header-note="{ text: '비고(보완계획)', width: '186' }"
      v-model="form.inspectList"
      class="mt-5">
      <template v-slot:trFooter>
        ※ 해당사항 이행하였거나 부서별 이행률 80% 이상 시 “양호”, 부서별 이행률 50~80% 시 “보통”, 미이행 및 부서별 이행률 50% 미만시 “미흡”
      </template>
    </table-inspect-merge>

    <!--    사진대지-->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검" />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import TableInspectDivisionEp from "@/components/TableInspectDivisionEp.vue";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import {inspectTable} from "./inspectData";

export default {
  components: {
    TableInspectMerge,
    TableInspectDivisionEp,
    CompanySelector,
    DateSelector,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        inputB_1: "",
        inputB_2: "",
        inputB_3: "",

        inspectList: [],

        stdInfo: {},
        fileList: [],
        photoList: [],
      },
    };
  },
  methods: {
    targetCompany(value) {
      this.form.inputB_1 = value.com_name;
    },
    updateListCheck(indexTableRow, indexRows, text) {
      this.form.inspectList[indexTableRow].list[indexRows].isChecked = text;
    },
  },
  computed: {
    inspectTable () {
      return JSON.parse(JSON.stringify(inspectTable))
    },
  }
};
</script>

<style scoped lang="scss">
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.input-se {
  width: 100%;
  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }
  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 20px !important;
  }
  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;
    position: relative;
    &::before {
      content: "~";
      width: 10px;
      position: absolute;
      left: -15px;
      text-align: center;
    }
  }
  &::v-deep .inline-block {
    width: 100% !important;
  }
}
</style>
